import api from "@/services/api";
import { PremiumVoucherHistoryItem } from "@/types/franchise-associate/PremiumVoucherHistory";

class GetPremiumVoucherHistory {
  execute = async () => {
    const response = await api().get("/premium-voucher-history");
    return response.data as PremiumVoucherHistoryItem[];
  };
}

export { GetPremiumVoucherHistory };
